const getDefaultState = () => {
  return {
    signUpIntent: null
  }
}

// initial state
const state = getDefaultState()

export const getters = {
  signUpIntent: state => state.signUpIntent
}

export const actions = {
  ResetSignUpIntentState (context) {
    context.commit('RESET_SIGNUPINTENT_STATE')
  },
  SetSignUpIntent(context, payloda) {
    context.commit('SET_SIGNUPINTENT', payloda)
  }
}

export const mutations = {
  SET_SIGNUPINTENT(state, payloda) {
    state.signUpIntent = payloda
  },
  RESET_SIGNUPINTENT_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
